<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'80px'"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('fileSearch.table.FileType')" prop="fileType">
            <BjSelectLov v-model="queryParams.fileType" :option-list="fileTypeList" :placeholder="$t('fileSearch.table.FileType')"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onImport">{{ $t('EXCELImportText') }}</el-button>
          <el-button type="primary" @click="showLog">{{ $t('logText')}}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <span v-if="col.prop === 'enabledFlag'">
                {{ scope.row.enabledFlag }}
              </span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onDownload(props.row.filePath, props.row.fileName)">{{ $t('downloadText') }}</el-button>
              <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <ExcelImportDialog2 ref="ExcelImport" @reFresh="$refs.BjPage.onSearch()" />
    <logDialog ref="logDialog"/>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { userApi } from '@/api';
import { STATUS_ENABLED_TRUE} from '@/utils/constants';
import dialogCompany from '../account/components/DialogCompany';
import ExcelImportDialog2 from './ExcelImportDialog2';
import logDialog from './logDialog';

export default {
  name: 'BusinessUserDepartmentBackupDetail',
  components: { dialogCompany,ExcelImportDialog2,logDialog },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_TRUE,
      selection: false,
      queryApi: userApi.getUserfileDetailsList,
      // 查询参数
      queryParams: {
        fileType: null,
        parentId: this.$route.query.parentId-0,
        cusId: this.$route.query.cusId || null,
        isDelete:0,
      },
      labelList: [
        { label: this.$t('AccountManagement.customer.companyName'), prop: 'companyName', isCheck: true, disabled: false },
        { label: this.$t('billingPage.FileName'), prop: 'fileName', isCheck: true, disabled: false },
        { label: this.$t('fileSearch.table.FileType'), prop: 'fileType', isCheck: true, disabled: false },
        { label: this.$t('BjDialogListConfig.Creationtime'), prop: 'creationDate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.createdAt'), prop: 'createdName', isCheck: true, disabled: false },
        { label: this.$t('table.remarkText'), prop: 'remarks', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false },
      ],
      fileTypeList: [
        {label:'Contract',value:'Contract'},
        {label:'Rate Card',value:'Rate Card'},
        {label:'Terms and Conditions',value:'Terms and Conditions'},
        {label:'Credit Application',value:'Credit Application'},
        {label:'Inbound Checklist',value:'Inbound Checklist'},
        {label:'Internal Handover Form',value:'Internal Handover Form'},
        {label:'IT Checklist',value:'IT Checklist'},
        {label:'Others',value:'Others'},
      ],
    };
  },
  methods: {
    /* 导入 */
    onImport() {
      this.$refs.ExcelImport.show();
    },
    // 日志
    showLog() {
      this.$refs.logDialog.show();
    },
    /* 下载 */
    onDownload(filePath, fileName) {
      console.log(filePath, fileName)
      fetch(filePath)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName || 'download.png';
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        });
    },
    /* 删除 */
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
          userApi.delUserfileDetailsList({id:row.id,parentId:this.queryParams.parentId,isDelete:1,cusId:this.queryParams.cusId}).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        })
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
